// Import custom modules
// __webpack_public_path__ = process.env.ASSET_PATH ? process.env.ASSET_PATH : null;
// window.FWP = window.FWP || {};
// FWP_JSON = window.FWP_JSON || {};
// var cookies = window.document.cookie ? window.document.cookie.split('; ') : [];
// import Cookies from '../woocommerce/assets/js/js-cookie/js.cookie.js';
// window.Cookies = Cookies;

// require('../../../facetwp-conditional-logic/assets/js/front');
// require('../../../facetwp/assets/js/src/event-manager');
// require('../../../facetwp/assets/js/src/query-string');
// require('../../../facetwp/includes/integrations/woocommerce/woocommerce');
// require('../../../facetwp/assets/js/dist/front.min');
// require('./libs/facet-wp-conditional');


// import '../woocommerce/assets/js/zoom/jquery.zoom';
// import '../woocommerce/assets/js/flexslider/jquery.flexslider';
// import '../../../woocommerce/assets/js/frontend/cart.min';
// import '../../../woocommerce/assets/js/frontend/add-payment-method.min';
// import '../../../woocommerce/assets/js/frontend/address-i18n.min';
// import '../../../woocommerce/assets/js/frontend/tokenization-form.min';
// import '../../../woocommerce/assets/js/frontend/checkout.min';
// import '../woocommerce/assets/js/frontend/cart-fragments';
// import '../woocommerce/assets/js/frontend/single-product';
// import '../../../woocommerce/assets/js/frontend/checkout';
// import '../woocommerce/assets/js/frontend/woocommerce';
// import '../../../paygreen-woocommerce/rsx/js/greenprint';
// import '../../../paygreen-woocommerce/rsx/js/client';
// import '../../../fluentform/public/js/form-submission';
import { run as bootCart } from './modules-front/add-to-cart';

var canOrder = false;
var currentProducts = 0;
let version = '1.0';

function onFacetsLoaded() {
    console.log('Facets loaded')
    if(jQuery('.site-main').get(0)) {
        jQuery('html, body').animate({ 
            scrollTop: jQuery('.site-main').get(0).offsetTop
        }, 150);
    }
    // setTimeout(() => loadImages(), 0);
    // setTimeout(() => loadLightBox(), 0);
    setTimeout(() => showFacets(), 0);
    setTimeout(() => measurementPrices(), 0);
    jQuery("div.quantity:not(.spinners-added)").addClass("spinners-added").append('<input type="button" value="+" class="plus" />').prepend('<input type="button" value="-" class="minus" />');
}

const priceTplPeople = (price, currency, u, p, unit, people) => `${price} <span class="woocommerce-Price-currencySymbol">${currency}</span>
<div class="conditioning"><span class="d-block woocommerce-Price-cunit">${u} ${unit}</span>
<span class="d-block woocommerce-Price-recommended">${p} ${people}</span></div>`;

const priceTplUnit = (price, currency, u, unit) => `${price} <span class="woocommerce-Price-currencySymbol">${currency}</span>
<div class="conditioning"><span class="d-block woocommerce-Price-cunit">${u} ${unit}</span></div>`;

const priceTpl = (price, currency) => `${price} <span class="woocommerce-Price-currencySymbol">${currency}</span>`;

const shouldPluralise = (data) => {
    if(!data) return false;
    let interpretable = String(data).split(/(\s+)/).filter( e => e.trim().length > 0);
    let isPlural = false;
    let l = interpretable.length;
    for (let i = l; i >= 0; i--) {
        if(parseFloat(interpretable[i]) > 1) {
            isPlural = true;
            break;
        };
    }
    return isPlural ? true : false;
}

function handleCard(card){
    let productInfo = {};
    productInfo = jQuery('.product-search-result', card);
    let priceCalculated = card.find('.calculated-price .product_price');
    let needed = card.find('.amount_needed');
    let fixedVal = parseFloat(needed.val() ? needed.val().replace(',','.') : null);
    if(fixedVal) {
        if(!needed.is("select")) {
            needed.val(fixedVal);
        }
        // jQuery('.add_to_cart_button', card).attr('data-weight_needed', fixedVal);
    }

    console.log("Debug", { condition: productInfo.attr('data-conditioning') })

    let priceCalcMethod = productInfo.attr('data-calc-unit');
    let priceTTC = productInfo.attr('data-pricettc');
    let neededUnit = productInfo.attr('data-unit');
    let attrs = productInfo.attr('data-conditioning') ? JSON.parse(productInfo.attr('data-conditioning')) : {};
    let conditioningUnit = productInfo.attr('data-conditioning-unit');

    
    console.log('Handling card:start', { card, needed, attrs, conditioningUnit });

    
    let attrForU = null;
    for (const key in attrs) {
        if (attrs.hasOwnProperty(key)) {
            const element = attrs[key];
            console.log(fixedVal, element)
            if(element['k'] == fixedVal) {
                attrForU = element['attr'];
            }
        }
    }
    let u = attrForU && typeof attrForU.u !== 'undefined' && attrForU.u ? attrForU.u : 1;
    let p = attrForU && typeof attrForU.p !== 'undefined' && attrForU.p ? attrForU.p : 1;
    
    let unit = shouldPluralise(u) ? conditioningUnit + 's' : conditioningUnit;
    let people = shouldPluralise(p) ? "personnes" : "personne";

    console.log('PriceCalcMethod is ::: ', { priceCalcMethod, productInfo});
    if(priceCalcMethod === 'fixed_kg' || priceCalcMethod === 'piece') {
        fixedVal = 1;
        productInfo.append('<input type="hidden" name="_fixed_price" value="true" />');
    }
    let price = typeof fixedVal !== 'undefined' && fixedVal 
    ? parseFloat(fixedVal * priceTTC).toFixed(2)
    : parseFloat(priceTTC).toFixed(2);
    
    console.log('Handling card:beforeset', { needed, fixedVal, price })

    // console.log('Handling card', { card, fixedVal, price, u, p, unit, people });
    if(attrForU && typeof attrForU.p !== 'undefined') {
        if(attrForU.p === null || attrForU.p === '') {
            priceCalculated.html(priceTplUnit(price, '€', u, unit));
        } else {
            priceCalculated.html(priceTplPeople(price, '€', u, p, unit, people));
        }
    } else {
        priceCalculated.html(priceTpl(price, '€'));
    }
    card.find('input[name="_measurement_needed"]').val(fixedVal);
    card.find('input[name="_measurement_needed_unit"]').val(neededUnit);
}

function measurementPrices(){
    console.log('recalc measurementPrices')
    jQuery('.loop-entry.product').each(function(){ // , .display-product
        setTimeout(() => handleCard(jQuery(this)), 0);
    });
}


function showFacets(){
    jQuery('.search-col-left, .top-filters').addClass('visible');
    jQuery('.facetwp-checkbox.checked').each(function(){
        let expandStatus = jQuery(this).find('.facetwp-expand');
        if(expandStatus.html() === '[+]') {
            expandStatus.html('[-]');
        }
        let subMenu = jQuery(this).next('.facetwp-depth');
        if(!subMenu.hasClass('visible')) {
            subMenu.addClass('visible');
        }
    })
}

function wooCheckoutFields(){
    jQuery('#billing_postcode, #shipping_postcode').attr('type', 'tel').attr('autocomplete','postal-code');
    jQuery('input.card-number').attr('placeholder', '•••• •••• •••• ••••').attr('autocomplete','cc-number').attr('type', 'tel');
    jQuery('.card-cvc').attr('placeholder', '•••').attr('autocomplete','cc-csc').attr('type', 'tel');
}


function updateFacetsOnLoad() {
    jQuery('.facetwp-type-checkboxes .facetwp-overflow').each(function() {
        var num = jQuery(this).find('.facetwp-checkbox').length;
        var $el = jQuery(this).siblings('.facetwp-toggle:first');
        $el.text($el.text().replace('{num}', num));
    });
}

function EPdoLoadEvents(){
    console.log('ACTIV E-repas prices', { version })
    // FWP.render(window.FWP_JSON.preload_data);
    // Global
    setTimeout(() => hookupEvents(), 0);
    setTimeout(() => initialStateForOrderTables(), 0);
    setTimeout(() => wooCheckoutFields(), 0);
    setTimeout(() => updateFacetsOnLoad(), 0);
    // Cart
    setTimeout(() => setPickupLocation(), 0);
    setTimeout(() => bootCart(), 0);
    
    // Plats du jours
    setTimeout(() => platsDuJour(), 0);
    
    // Validate page
    setTimeout(() => validatePage(), 100);

    return true;
}

let EPLoaded = false;
jQuery(document).ready(function($) {
    if(!EPLoaded) {
        setTimeout(() => EPLoaded = EPdoLoadEvents(), 0)
    }
});



function platsDuJour(){
    if( jQuery('.plats-select-day.module-plats-du-jour').length >= 1 ) {
        console.log('Boot plats du jour')
        // if(location.href.includes('plat-du-jour')) {
        handleSelectChange(function(hasOperation){
            console.log('Status after load:', hasOperation);
            maybeDisplayMessageNoOperations(hasOperation);
            initialStateForOrderTables();
        })
        maybeSelectToday();
    }

    if( jQuery('.plats-select-day.module-operation-produit').length >= 1 ) {
        console.log('Boot operation produit')
        // if(location.href.includes('plat-du-jour')) {
        handleSelectChange(function(hasOperation){
            console.log('Status after load:', hasOperation);
            maybeDisplayMessageNoOperations(hasOperation);
            initialStateForOrderTables();
        })
        maybeSelectToday();
    }
}

function operationNotFound() {
    jQuery(".operation-loading, .operation-addToCartLoader, .operations-list").hide();
    jQuery(".operation-notfound").show();
}

function setPickupLocation() {
    // jQuery('#user_pickup_location').val(jQuery("#user_pickup_location option:first").val());
    jQuery("#user_pickup_location option:eq(1)").attr("selected", "selected");

    let checked;
    jQuery('input[name="shipping_method[0]"]').each(function(){ 
        if(jQuery(this).attr('checked')) {
            checked =jQuery(this).val() 
        }
    })

    // if(checked === 'local_pickup_plus') {
    //     jQuery('.woocommerce-shipping-fields').hide();
    // } else {
    //     jQuery('.woocommerce-shipping-fields').show();
    // }

    // jQuery('body').on('change', 'input.shipping_method', function(){
    //     let input = jQuery(this).val();
    //     jQuery('#ship-to-different-address-checkbox').attr('checked', false);
    //     jQuery('.shipping_address').find('input, select').val('');
    //     if(input === 'local_pickup_plus') {
    //         jQuery('.woocommerce-shipping-fields').hide();
    //     } else {
    //         jQuery('.woocommerce-shipping-fields').show();
    //     }
    // });
}

function handleSelectChange(callback) {
    jQuery("body").on("change", ".ajax-select", function() {
        var contentPlaceholder = jQuery(".dynamic-product-list-wrapper");
        var target = jQuery("option:selected", this).attr("data-permalink");
        console.log("Should load new page", target);
        if (target) {
            contentPlaceholder
            .first()
            .html("");
            
            jQuery(".operation-notfound").hide()
            jQuery(".operation-loading").show()
            
            contentPlaceholder
            .load(target + " .dynamic-content-wrapper", function() {
                callback(true);
            });
            // jQuery('.operation-notfound').hide();
            // jQuery('.operation-found').show();
        } else {
            contentPlaceholder.html("").end();
            callback(false);
            // jQuery('.operation-notfound').show();
            // jQuery('.operation-found').hide();
        }
    });
}

function validatePage() {
    console.log('Validating page:', { currentProducts })
    if(currentProducts <= 0) {
        jQuery('.boucherie-commander').addClass('disabled');
    } else {
        jQuery('.boucherie-commander').removeClass('disabled');
    }

}

function hookupEvents() {
    console.log('hookupEvents');

    jQuery('#ship-to-different-address-checkbox').on('change', function() {
        console.log('Ship to different address checkbox changed');
        jQuery( '#shipping_country' ).val(jQuery('#billing_country').val())
    })
    
    // jQuery(document.body).on('change', '.shipping_method', function(){
    //     console.log('Shipping method updated')
    //     setTimeout(function(){ runCheckoutLogic(); }, 2000);
    // })
    jQuery(document.body).on('update_checkout', function(){
        console.log('Checkout updated')
        // setTimeout(function(){ runCheckoutLogic(); }, 3000);
    })
    // setTimeout(function(){ runCheckoutLogic(); }, 100);

    jQuery("body").on("click", ".boucherie-commander", function() {
        var temp_number = jQuery(this).data("temp_number");
        customOrderTableEvents(temp_number);
        return false;
    });

    // jQuery('body').on('change', '.product-search-result .amount_needed', function(){
    //     handleCard(jQuery(this).closest('.product-search-result'));
    // });
    
    jQuery('body').on('change', '.product .amount_needed', function(){
        console.log('change:amount_needed')
        setTimeout(() => handleCard(jQuery(this).closest('.loop-entry.product')), 0);
    });

    
    jQuery(document).on('facetwp-loaded', () => { onFacetsLoaded(); });
    // setTimeout(() => loadLightBox(), 0);
    setTimeout(() => showFacets(), 0);
    setTimeout(() => measurementPrices(), 0);

    let timeout = null;
    jQuery(document.body).on('change', 'input.qty', function(){
        console.log('Update cart');
		if ( timeout !== undefined ) {
			clearTimeout( timeout );
		}
 
		timeout = setTimeout(function() {
			jQuery("[name='update_cart']").prop("disabled", false).trigger("click");
		}, 500 ); // 1 second delay, half a second (500) seems comfortable too
	});
    
    // Handle +/- for tables
    jQuery("body").on("click", ".qib-button.plus", function() {
        console.log('Increment');
        let qtyInput = jQuery(this).parent().find('.qty');
        let val = parseInt(qtyInput.val(), 10);
        qtyInput.val(val + 1).trigger('change');
        currentProducts = currentProducts + 1;
        validatePage();
    });
    
    jQuery("body").on("click", ".qib-button.minus", function() {
        console.log('Decrement');
        let qtyInput = jQuery(this).parent().find('.qty');
        let val = parseInt(qtyInput.val(), 10);
        if (val > 0) {
            let newVal = val - 1;
            qtyInput.val(newVal).trigger('change');
            currentProducts = newVal;
            validatePage();
        }
    });

    // Handle +/- for cart
    // jQuery("body").on("click", ".woocommerce-cart-form__contents .plus", function() {
    //     jQuery(".actions .button[name=update_cart]").trigger("click");
    // });
    
    // jQuery("body").on("click", ".woocommerce-cart-form__contents .minus", function() {
    //     jQuery(".actions .button[name=update_cart]").trigger("click");
    // });


}

            
function setSelectsTo0() {
    jQuery(".operation-content td.wpt_check input").prop("checked", true);
    jQuery(".operation-content td input.qty").val(0);
}
            
function maybeDisplayMessageNoOperations(show) {
    if (!show) {
        jQuery(".operation-loading").fadeOut()
            .end()
            .find(".operation-notfound")
            .fadeIn();
        jQuery(".operations-list").hide();
    } else {
        jQuery(".operation-loading").hide();
        jQuery(".operation-notfound").hide();
        jQuery(".operations-list").show();
    }
}
            
function maybeSelectToday() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    var todayOptionVal = yyyy + "-" + mm + "-" + dd;
    console.log("Try select date:", todayOptionVal);
    if(jQuery(".ajax-select option[value='" + todayOptionVal + "']").lengh) {
        jQuery(".ajax-select option[value='" + todayOptionVal + "']")
        .attr("selected", "selected")
        .trigger("change");
    } else {
        if(jQuery(".ajax-select option").length > 1) {
            jQuery(".ajax-select option").eq(1).attr("selected", "selected")
            .trigger("change");
        } else {
            console.log('Cannot find plat du jour for:', todayOptionVal);
            operationNotFound();
        }
    }
    
}

function initialStateForOrderTables(){
    console.log("Prepare state for order tables");
    setSelectsTo0();
}

function customOrderTableEvents(temp_number) {
    var checkoutURL = jQuery("#table_id_" + temp_number).data("checkout_url");
    //Add Looading and Disable class
    var currentAllSelectedButtonSelector = jQuery(
        "#table_id_" + temp_number + " a.button.add_to_cart_all_selected"
        );
        currentAllSelectedButtonSelector.addClass("disabled");
        currentAllSelectedButtonSelector.addClass("loading");
        
        var add_cart_text = jQuery("#table_id_" + temp_number).data("add_to_cart");
        
        //Getting Data from all selected checkbox
        var products_data = {};
        var itemAmount = 0;
        
        jQuery(
            "#table_id_" +
            temp_number +
            " input.enabled.wpt_tabel_checkbox.wpt_td_checkbox:checked"
            ).each(function() {
                var product_id = jQuery(this).data("product_id");
                var thisButton = jQuery(
                    "tr.wpt_row_product_id_" +
                    product_id +
                    " td.wpt_action a.button.wpt_woo_add_cart_button"
                    );
                    thisButton.removeClass("added");
                    thisButton.addClass("disabled");
                    thisButton.addClass("loading");
                    
                    //added at 4
                    var qtyElement = jQuery(
                        "#table_id_" +
                        temp_number +
                        " #product_id_" +
                        product_id +
                        " input.input-text.qty.text"
                        );
                        var min_quantity = qtyElement.attr("min") ? qtyElement.attr("min") : 0;
                        // if(min_quantity === '0' || typeof min_quantity === 'undefined'){
                        //     min_quantity = 1;
                        // }
                        
                        var currentAddToCartSelector = jQuery(
                            "#table_id_" +
                            temp_number +
                            " #product_id_" +
                            product_id +
                            " .wpt_action a.wpt_woo_add_cart_button"
                            );
                            var currentCustomMessage = jQuery(
                                "#table_id_" +
                                temp_number +
                                " #product_id_" +
                                product_id +
                                " .wpt_Message input.message"
                                ).val();
                                var currentVariaionId = currentAddToCartSelector.data("variation_id");
                                var currentVariaion = currentAddToCartSelector.data("variation");
                                var currentQantity = jQuery(
                                    "#table_id_" +
                                    temp_number +
                                    " table#wpt_table .wpt_row_product_id_" +
                                    product_id +
                                    " .wpt_quantity .quantity input.input-text.qty.text"
                                    ).val();
                                    
                                    if (currentQantity > 0) {
                                        var args = {
                                            product_id: product_id,
                                            quantity: currentQantity,
                                            variation_id: currentVariaionId,
                                            variation: currentVariaion,
                                            custom_message: currentCustomMessage
                                        };
                                        console.log("Adding to cart", args);
                                        products_data[product_id] = args;
                                        itemAmount++;
                                    }
                                });
                                
                                //Return false for if no data
                                if (itemAmount < 1) {
                                    currentAllSelectedButtonSelector.removeClass("disabled");
                                    currentAllSelectedButtonSelector.removeClass("loading");
                                    alert("Veuillez choisir des produits.");
                                    return false;
                                }
                                
                                if(jQuery("#content").length) {
                                    jQuery([document.documentElement, document.body]).animate({
                                        scrollTop: jQuery("#content").offset().top
                                    }, 0);
                                }
                                

                                jQuery(".operation-addToCartLoader").show();
                                jQuery('.operations-list').hide();
                                
                                jQuery.ajax({
                                    type: "POST",
                                    url: woocommerce_params.ajax_url,
                                    data: {
                                        action: "wpt_ajax_mulitple_add_to_cart",
                                        products: products_data
                                    },
                                    complete: function() {
                                        jQuery(document).trigger("wc_fragments_refreshed");
                                    },
                                    success: function(response) {
                                        //setFragmentsRefresh( response );
                                        //WPT_MiniCart();
                                        jQuery(document.body).trigger("added_to_cart", [
                                            response.fragments,
                                            response.cart_hash,
                                            jQuery("added_to_cart")
                                        ]);
                                        
                                        // currentAllSelectedButtonSelector.html(add_cart_text + ' [ ' + itemAmount + ' ' + config_json.add2cart_all_added_text + ' ]');
                                        // if(config_json.popup_notice === '1'){
                                        //     WPT_NoticeBoard();//Loading Notice Board
                                        // }
                                        // if(config_json.all_selected_direct_checkout === 'yes'){
                                        //     window.location.href = checkoutURL;
                                        //     return;
                                        // }else{
                                        currentAllSelectedButtonSelector.removeClass("disabled");
                                        currentAllSelectedButtonSelector.removeClass("loading");
                                        // }
                                        
                                        //Added at v4.0.11
                                        jQuery(
                                            "#table_id_" +
                                            temp_number +
                                            " input.enabled.wpt_tabel_checkbox.wpt_td_checkbox:checked"
                                            ).each(function() {
                                                var product_id = jQuery(this).data("product_id");
                                                
                                                var thisButton = jQuery(
                                                    "tr.wpt_row_product_id_" +
                                                    product_id +
                                                    " td.wpt_action a.button.wpt_woo_add_cart_button"
                                                    );
                                                    thisButton.removeClass("disabled");
                                                    thisButton.removeClass("loading");
                                                    thisButton.addClass("added");
                                                    
                                                    var qtyElement, min_quantity;
                                                    qtyElement = jQuery(
                                                        "#table_id_" +
                                                        temp_number +
                                                        " #product_id_" +
                                                        product_id +
                                                        " input.input-text.qty.text"
                                                        );
                                                        min_quantity = qtyElement.attr("min");
                                                        if (min_quantity === "0" || typeof min_quantity === "undefined") {
                                                            min_quantity = 1;
                                                        }
                                                        qtyElement.val(min_quantity); //Added at v4
                                                    });
                                                    
                                                    location.href = "/panier/";
                                                    // uncheckAllCheck(temp_number);
                                                },
                                                error: function() {
                                                    alert("Failed");
                                                }
                                            });
}




